<template>
    <div ref="barchart" style="width: 100%;height: 100%;"></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    props: {
        title: Array,
        data: Array
    },
    data() {
        return {
            options: {
                legend: { textStyle: { color: '#ffffff' } },
                tooltip: {},
                dataset: {
                    dimensions: [],
                    source: [
                        // { product: 'Matcha Latte', 2015: 43.3, 2016: 85.8, 2017: 93.7 },
                        // { product: 'Milk Tea', 2015: 83.1, 2016: 73.4, 2017: 55.1 },
                        // { product: 'Cheese Cocoa', 2015: 86.4, 2016: 65.2, 2017: 82.5 },
                        // { product: 'Walnut Brownie', 2015: 72.4, 2016: 53.9, 2017: 39.1 }
                    ]
                },
                xAxis: {
                    type: 'category',
                    axisLabel: { color: '#ffffff' }
                },
                yAxis: {
                    axisLabel: { color: '#ffffff' },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#77AFFF',
                            type: 'dashed'
                        }
                    }
                },
                // Declare several bar series, each will be mapped
                // to a column of dataset.source by default.
                series: [
                    {
                        type: 'bar',
                        itemStyle: {

                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(64,158,255,0.3)' },
                                { offset: 1, color: 'rgba(64,158,255,0.05)' }
                            ])
                        }
                    },
                    {
                        type: 'bar',
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(103,194,58,0.3)' },
                                { offset: 1, color: 'rgba(103,194,58,0.05)' }
                            ])
                        }
                    },
                    {
                        type: 'bar',
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#5aabff' },
                                { offset: 1, color: 'rgba(54, 207, 201, 0.2)' }
                            ])
                        }
                    }
                ]
            }
        }
    },
    watch: {
        data(val) {
            this.options.dataset.dimensions = this.$props.title
            this.options.dataset.source = val

            // 重新初始化series，确保使用渐变色
            this.options.series = [
                {
                    type: 'bar',
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#1FF0FF' },
                            { offset: 0.25, color: '#0084FF' },
                            { offset: 1, color: 'rgba(0, 132, 255, 0.2)' }
                        ])
                    }
                },
                {
                    type: 'bar',
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#93CF76' },
                            { offset: 0.5, color: '#67C23A' },
                            { offset: 1, color: 'rgba(103, 194, 58, 0.2)' }
                        ])
                    }
                },
                {
                    type: 'bar',
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: '#5aabff' },
                            { offset: 0.5, color: '#36cfc9' },
                            { offset: 1, color: 'rgba(54, 207, 201, 0.2)' }
                        ])
                    }
                }
            ]

            this.init()
        }
    },
    methods: {
        init() {
            var myChart = echarts.init(this.$refs.barchart)

            myChart.setOption(this.options, true)
            window.addEventListener('resize', function () {
                myChart.resize();
            });
        }
    }
}
</script>

<style scoped></style>